import styled from 'styled-components';
import { theme } from './outputTheme';

export const CodeBlockContainer = styled.div`
  position: relative;
`;

export const Pre = styled.pre`
  margin: 0;
  padding: 16px;
  background-color: ${theme.plain.backgroundColor};
  border-radius: 8px;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 1.5;
`;

export const Caption = styled.div`
  padding: 8px 12px;
  background-color: ${theme.plain.backgroundColor};
  color: ${theme.plain.color};
  border-top: 1px solid transparent;
  border-bottom: 1px solid #4fd1c5;
`;

export const Spacer = styled.div`
  flex: 1 1 auto;
  padding-top: 8px;
  overflow: hidden;
  border-top-left-radius: 8px;
`;

export const CopyButtonContainer = styled.div`
  position: absolute;
  top: 9px;
  right: 5px;
  display: flex;
  align-items: center;
  height: 32px;
  padding-left: 16px;
`;

export const CopyButton = styled.button`
  color: ${theme.styles[0].style.color};
  background-color: ${theme.plain.backgroundColor};
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
`;

export const CodeContent = styled.div`
  padding: 16px;
  overflow: auto;
  font-size: 14px;
  color: ${theme.plain.color};
`;

export const Fade = styled.div`
  position: absolute;
  top: 45px;
  right: 0;
  width: 32px;
  background: linear-gradient(to left, #000, transparent);
`;
